import { render, staticRenderFns } from "./DownTimeRecords.vue?vue&type=template&id=a72ae0bc"
import script from "./DownTimeRecords.vue?vue&type=script&lang=js"
export * from "./DownTimeRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports